import apiClient from './api'
import { DepositTransaction, WithdrawalTransaction, SmsWithdrawalRequest } from '@/types/transactions'

export interface TransactionQuery {
  msisdn?: string
  paybill?: string
  status?: string
  channel?: string
  external_transaction_id?: string
  start_date?: string
  end_date?: string
  page?: number
  page_size?: number
}

export interface PaginatedResponse<T> {
  items: T[]
  pagination: {
    page: number
    pageSize: number
    total: number
  }
}

export const transactionService = {
  fetchDeposits: (params: TransactionQuery = {}) =>
    apiClient.get<PaginatedResponse<DepositTransaction>>('/deposits', { params }).then((res) => res.data),
  fetchWithdrawals: (params: TransactionQuery = {}) =>
    apiClient.get<PaginatedResponse<WithdrawalTransaction>>('/withdrawals', { params }).then((res) => res.data),
  fetchSmsRequests: (params: TransactionQuery = {}) =>
    apiClient.get<PaginatedResponse<SmsWithdrawalRequest>>('/sms-withdrawal-requests', { params }).then((res) => res.data),
}

